import React from "react";

/**
 * SuiteEyebrow — etichetta piccola uppercase tracking-widest.
 * È l'elemento identitario delle sezioni della Gruppo Impresa Suite.
 *
 * Props:
 *  - children:    testo dell'eyebrow (obbligatorio)
 *  - tone:        "primary" (default) | "neutral" | "secondary" | "warning" | "error" | "accent"
 *  - icon:        componente icona Lucide (opzionale)
 *  - as:          tag html ("div", "span", "p"), default "div"
 *  - className:   classi extra opzionali
 */
export function SuiteEyebrow({ children, tone = "primary", icon: Icon, as: As = "div", className = "", ...rest }) {
  const toneMap = {
    primary:   "text-suite-primary",
    accent:    "text-suite-accent-hover",
    secondary: "text-suite-secondary",
    warning:   "text-suite-warning",
    error:     "text-suite-error",
    neutral:   "text-suite-neutral-500",
  };
  return (
    <As
      className={`text-xs uppercase tracking-[0.2em] font-semibold inline-flex items-center gap-1.5 ${toneMap[tone] || toneMap.primary} ${className}`}
      {...rest}
    >
      {Icon ? <Icon size={12} strokeWidth={2} /> : null}
      {children}
    </As>
  );
}

export default SuiteEyebrow;
